(function () {
  const WISHLIST_KEY = 'shopify_wishlist';

  // Shared from mtc-card-badges.js, which is always loaded before this script.
  const escHtml = window.Mtc.escHtml;

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  const ADD_TO_CART_ICON = `<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="var(--icon-stroke-width)" d="M14.608 12.563v5m2.5-2.5h-5"/></svg>`;

  function buildAddToCartHtml(product) {
    const variant = product.variants[0];
    const btnInner = (text) =>
      `<span class="svg-wrapper add-to-cart-icon" aria-hidden="true">${ADD_TO_CART_ICON}</span>${escHtml(text)}`;
    if (product.variants.length === 1) {
      return `<form action="/cart/add" method="post" class="wishlist-item__buy-form">
        <input type="hidden" name="id" value="${escHtml(String(variant.id))}">
        <input type="hidden" name="quantity" value="1">
        <button type="submit" class="button wishlist-item__buy-btn"${variant.available ? '' : ' disabled'}>
          ${variant.available ? btnInner('Add') : escHtml('Out of stock')}
        </button>
      </form>`;
    }
    return `<a href="${escHtml(product.url)}" class="button wishlist-item__buy-btn">${btnInner('Choose options')}</a>`;
  }

  function buildCard(product, colorScheme) {
    const variant = product.variants[0];
    const price = (variant.price / 100).toFixed(2);
    const title = escHtml(product.title);
    const wishlisted = getWishlist().includes(product.handle);
    const badges = window.MtcCardBadges;
    const schemeClass = colorScheme ? ` color-${escHtml(colorScheme)}` : '';

    return `<div class="wishlist-item${schemeClass}">
      <a href="${escHtml(product.url)}" class="product-card__link">
        <span class="visually-hidden">${title}</span>
      </a>
      <div class="wishlist-item__media product-media">
        <button
          type="button"
          class="wishlist-btn wishlist-btn-style${wishlisted ? ' is-active' : ''}"
          data-wishlist-toggle="${escHtml(product.handle)}"
          aria-label="${wishlisted ? 'Remove from checklist' : 'Add to checklist'}"
        >
          <span class="wishlist-icon"></span>
        </button>
        <img src="${escHtml(product.featured_image)}" alt="" loading="lazy">
        ${badges ? badges.buildBulkBadge(product.handle, variant.available) : ''}
        ${badges ? badges.buildProductBadge(product) : ''}
      </div>
      <div class="wishlist-item__content">
        <h3 class="h6 wishlist-item__heading">${title}</h3>
        <p class="h5 wishlist-item__price">${product.available ? `£${price}` : ''}</p>
        ${buildAddToCartHtml(product)}
      </div>
    </div>`;
  }

  const PRODUCT_CACHE_PREFIX = 'mtc_product_cache__';
  const PRODUCT_CACHE_TTL = 30 * 60 * 1000; // 30 minutes in ms

  function getCached(handle) {
    try {
      const raw = localStorage.getItem(PRODUCT_CACHE_PREFIX + handle);
      if (!raw) return null;
      const { data, cachedAt } = JSON.parse(raw);
      if (Date.now() - cachedAt > PRODUCT_CACHE_TTL) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function setCached(handle, data) {
    try {
      localStorage.setItem(PRODUCT_CACHE_PREFIX + handle, JSON.stringify({ data, cachedAt: Date.now() }));
    } catch (e) {
      // localStorage full or unavailable — silently skip caching
    }
  }

  async function fetchProducts(handles) {
    const requests = handles.map((handle) => {
      const cached = getCached(handle);
      if (cached) return Promise.resolve(cached);
      return fetch(`/products/${encodeURIComponent(handle)}.js`)
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => {
          if (data) setCached(handle, data);
          return data;
        });
    });
    return (await Promise.all(requests)).filter(Boolean);
  }

  window.MtcProductCard = { buildCard, fetchProducts };
})();
